import React from 'react';
import { WebsiteDesignProps } from './types';
import { Scale, Gavel, FileText } from 'lucide-react';
import { Button } from "@/components/ui/button";

const LawSchool: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "School of Law";

    return (
        <div className="bg-[#3e000c] text-white min-h-screen font-serif">
            <nav className="border-b border-white/20 p-8 flex justify-between items-center bg-[#2b0008]">
                <div className="text-2xl font-medium tracking-tight uppercase flex items-center gap-3">
                    <Scale className="text-[#bf9b30]" /> {schoolName}
                </div>
                <div className="hidden md:flex gap-8 text-sm font-sans font-bold uppercase tracking-widest text-[#bf9b30]">
                    <a href="#" className="hover:text-white transition-colors">Faculty</a>
                    <a href="#" className="hover:text-white transition-colors">Journals</a>
                    <a href="#" className="hover:text-white transition-colors">Library</a>
                </div>
            </nav>

            <header className="py-24 px-8 text-center relative overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')] opacity-30 pointer-events-none"></div>
                <div className="relative z-10 max-w-4xl mx-auto">
                    <div className="mb-6 mx-auto w-20 h-20 border-2 border-[#bf9b30] rounded-full flex items-center justify-center">
                         <Gavel className="text-[#bf9b30]" size={40} />
                    </div>
                    <h1 className="text-5xl md:text-7xl font-medium mb-6 leading-tight text-white">
                        Justice for All.
                    </h1>
                    <p className="text-xl text-[#e5e5e5] mb-12 font-sans font-light max-w-2xl mx-auto">
                        An education steeped in history, rigor, and the relentless pursuit of fairness. 
                    </p>
                    <div className="flex justify-center gap-6 font-sans">
                        <Button className="bg-[#bf9b30] text-[#3e000c] hover:bg-[#d4af37] font-bold uppercase tracking-widest px-8">
                            Apply
                        </Button>
                        <Button variant="outline" className="border-white text-white hover:bg-white/10 font-bold uppercase tracking-widest px-8">
                            Visit
                        </Button>
                    </div>
                </div>
            </header>

            <section className="bg-[#fcfbf9] text-[#2b0008] py-20 font-sans">
                <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
                     <div className="border-t-4 border-[#3e000c] pt-6">
                         <h3 className="text-2xl font-serif font-bold mb-4">Juris Doctor</h3>
                         <p className="text-gray-600 leading-relaxed mb-4">Our flagship three-year program prepares students for bar admission and legal practice at the highest levels.</p>
                         <a href="#" className="text-[#bf9b30] font-bold uppercase text-xs tracking-widest hover:underline">View Requirements</a>
                     </div>
                     <div className="border-t-4 border-[#3e000c] pt-6">
                         <h3 className="text-2xl font-serif font-bold mb-4">LL.M Programs</h3>
                         <p className="text-gray-600 leading-relaxed mb-4">Advanced degrees for foreign-trained lawyers and specialists in taxation, human rights, and more.</p>
                         <a href="#" className="text-[#bf9b30] font-bold uppercase text-xs tracking-widest hover:underline">View Specializations</a>
                     </div>
                     <div className="border-t-4 border-[#3e000c] pt-6">
                         <h3 className="text-2xl font-serif font-bold mb-4">Clinics</h3>
                         <p className="text-gray-600 leading-relaxed mb-4">Hands-on legal experience representing real clients under the supervision of expert faculty.</p>
                         <a href="#" className="text-[#bf9b30] font-bold uppercase text-xs tracking-widest hover:underline">Our Impact</a>
                     </div>
                </div>
            </section>
        </div>
    );
};

export default LawSchool;
